import api from '@/apis/di/statisticAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useStatisticComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onStatisticComboboxLoadData = (payload, row, column, customData) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'statistic_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const statisticComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã thống kê',
        dataField: 'statistic_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên thống kê',
        dataField: 'statistic_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'statistic_code',
    valueField: 'statistic_id',
    queryMode: 'remote',
    quickSearch: 'StatisticQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onStatisticComboboxLoadData,
  };

  return {
    statisticComboConfig,
    onStatisticComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
